import { render } from "./Asset_Profile.vue?vue&type=template&id=25cb880a&scoped=true"
import script from "./Asset_Profile.vue?vue&type=script&lang=js"
export * from "./Asset_Profile.vue?vue&type=script&lang=js"

import "./Asset_Profile.vue?vue&type=style&index=0&id=25cb880a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25cb880a"]])

export default __exports__